import React from 'react';
import AboutUs from '../Components/AboutUs';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import SubmitArea from '../Components/SubmitArea';

const About = () => {
    return (
       <div>
       <Header/>
        <AboutUs/>
        <SubmitArea/>
        <Footer/>
        </div>
    );    
};

export default About;

